export const CREATE_FOLDER_FIELDS = {
  NAME: "name",
} as const;
